import { Component } from '@angular/core';

@Component({
    selector: 'app-no-server-dialog-body',
    templateUrl: './no-server-dialog-body.component.html',
    styleUrls: ['./no-server-dialog-body.component.scss']
})
export class NoServerDialogBodyComponent {}
